import swal from 'sweetalert2';
import AdminApi from '../../services/api';
import session from '../../services/session';
import CONFIG_COMPANY from '../../services/myConfig';
import Loc from '../../services/localization';

const AdminApiService = new AdminApi();
const LocService = new Loc();

export default {
  data() {
    return {
      role: '',
      locale: LocService,
      shops: [],
      shopsActions: [],
      showQrCodeItem: null,
      shopSearch: '',
      selectedCategoryChip: 'all',
      isFullscreen: false,
    };
  },
  computed: {
    normalizedShopSearch() {
      return (this.shopSearch || '').toString().toLowerCase().trim();
    },
    mergedShopItems() {
      return (this.shopsActions || []).concat(this.shops || []);
    },
    categoryChips() {
      const categories = [];
      const map = {};

      (this.mergedShopItems || []).forEach((item) => {
        const category = (item && item.category ? String(item.category) : '').trim();
        if (category.length === 0) return;

        const key = category.toLowerCase();
        if (!map[key]) {
          map[key] = true;
          categories.push(category);
        }
      });

      return categories;
    },
    filteredShopItems() {
      const query = this.normalizedShopSearch;
      const category = this.selectedCategoryChip;

      return (this.mergedShopItems || []).filter((item) => {
        const itemName = this.getCompanyInfoName(item).toLowerCase();
        const itemCategory = (item && item.category ? String(item.category) : '').toLowerCase().trim();

        const searchMatch = query.length === 0 || itemName.indexOf(query) > -1;
        const categoryMatch = category === 'all' || itemCategory === String(category).toLowerCase().trim();

        return searchMatch && categoryMatch;
      });
    },
  },
  methods: {
    getNotifications: getNotifications,
    convertAdditionalInfo: convertAdditionalInfo,
    getDiscountPrice: getDiscountPrice,
    getCompanyInfoName: getCompanyInfoName,
    money(v, currencyValue) {
      return new Intl.NumberFormat('sr-RS', {
        style: 'currency',
        currency: currencyValue,
        minimumFractionDigits: 0,
      }).format(v);
    },
    stockLabel(p) {
      return p.stockNumber <= 0
        ? LocService.t('label_cart_not_on_stock')
        : (p.stockNumber <= p.lowStockThreshold ? `⚠ ${p.stockNumber}` : `${p.stockNumber}`);
    },
    stockClass(p) {
      return p.stockNumber <= 0 ? 'oos' : (p.stockNumber <= p.lowStockThreshold ? 'low' : 'ok');
    },
    selectCategoryChip(value) {
      this.selectedCategoryChip = value;
    },
    isCategorySelected(value) {
      return this.selectedCategoryChip === value;
    },
    onShopItemClick(item) {
      this.showQrCodeForItem(item);
    },
    toggleFullscreen: toggleFullscreen,
    requestFullscreen: requestFullscreen,
    exitFullscreen: exitFullscreen,
    onFullscreenChange: onFullscreenChange,
    showQrCodeForItem: showQrCodeForItem,
    isLoggedIn() {
      return session.getAccessToken() !== null && session.getAccessToken().length > 0;
    },
  },
  created() {
    const _self = this;
    this.$topnavbar.$on('closeShowQrCode', () => {
      _self.showQrCodeItem = null;
    });

    document.addEventListener('fullscreenchange', this.onFullscreenChange);
    document.addEventListener('webkitfullscreenchange', this.onFullscreenChange);
    document.addEventListener('msfullscreenchange', this.onFullscreenChange);
  },
  beforeDestroy() {
    document.removeEventListener('fullscreenchange', this.onFullscreenChange);
    document.removeEventListener('webkitfullscreenchange', this.onFullscreenChange);
    document.removeEventListener('msfullscreenchange', this.onFullscreenChange);
  },
  beforeMount() {
    if (!this.isLoggedIn()) {
      this.$router.push('/login');
      return;
    }

    this.role = session.getRole();
    if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_TRAINER') {
      this.$router.push(CONFIG_COMPANY.HOME);
      return;
    }

    this.getNotifications();
  },
};

function getNotifications() {
  const _self = this;
  AdminApiService.getAllForHomePage()
    .then((response) => {
      _self.shops = (response.data.companyInfos || []).filter((e) => e.type === 'SHOP');
      _self.shops.forEach((e) => {
        e.addInfo = _self.convertAdditionalInfo(e.additionalInfo);
        e.discountPrice = _self.getDiscountPrice(e.addInfo);
      });

      _self.shopsActions = _self.shops.filter((e) => e.discountPrice.length > 0);
      _self.shops = _self.shops.filter((e) => e.discountPrice.length === 0);
    })
    .catch((error) => {
      swal(LocService.t('label_error'), error.data.localized_error_message, 'error');
    });
}

function convertAdditionalInfo(additionalInfo) {
  return JSON.parse(additionalInfo);
}

function getDiscountPrice(addInfo) {
  if (addInfo == null) return '';
  if (addInfo.discount == null) return '';
  try {
    const discountPrice = addInfo.discount != null ? parseInt(addInfo.discount) : 0;
    const price = addInfo.price != null ? parseFloat(addInfo.price) : 0.0;
    return (price - price * (discountPrice / 100)).toFixed(2);
  } catch (e) {
    return '';
  }
}

function getCompanyInfoName(item) {
  if (session.getLocale() === LocService.getDefaultLanguage()) {
    return item.name;
  }
  if (item.enName != null && item.enName.length > 0) {
    return item.enName;
  }
  return item.name;
}

function showQrCodeForItem(item) {
  this.showQrCodeItem = item;
}

async function requestFullscreen() {
  const el = document.documentElement;
  try {
    if (el.requestFullscreen) {
      await el.requestFullscreen();
      return;
    }
    if (el.webkitRequestFullscreen) {
      await el.webkitRequestFullscreen();
      return;
    }
    if (el.msRequestFullscreen) {
      await el.msRequestFullscreen();
    }
  } catch (e) {
    swal(LocService.t('label_error'), LocService.t('label_fullscreen_failed'), 'error');
  }
}

async function exitFullscreen() {
  try {
    if (document.exitFullscreen) {
      await document.exitFullscreen();
      return;
    }
    if (document.webkitExitFullscreen) {
      await document.webkitExitFullscreen();
      return;
    }
    if (document.msExitFullscreen) {
      await document.msExitFullscreen();
    }
  } catch (e) {
    swal(LocService.t('label_error'), LocService.t('label_fullscreen_failed'), 'error');
  }
}

function onFullscreenChange() {
  const fullElement =
    document.fullscreenElement ||
    document.webkitFullscreenElement ||
    document.msFullscreenElement;
  this.isFullscreen = !!fullElement;
}

async function toggleFullscreen() {
  if (this.isFullscreen) {
    await this.exitFullscreen();
  } else {
    await this.requestFullscreen();
  }
}



// WEBPACK FOOTER //
// ./src/components/Shop/ShopPageQr.js